import React, { useMemo } from "react";
import styled from "styled-components";
import image from "./assets/logo_primary_background_1.png";
import fitness from "./assets/fitness.png";
import queryString from "query-string";
import android from "./assets/android-logo.png";
import apple from "./assets/apple.png";

const Container = styled.div`
  background-color: #222222;
  display: "flex";
  align-items: "center";
  align-content: "center";
  align-self: center;
  justify-content: "center";
  margin: auto;
  width: 100vw;
  color: white;
  font-family: "Oxanium";
  min-height: 100vh;
  padding-bottom: 50px;
  img {
    padding-top: 100px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  h1 {
    color: white;
    margin-right: auto;
    margin-left: auto;
    width: 50%;
    text-align: center;
    font-size: 27px;
    font-weight: bolder;
  }
  div.outer {
    margin: auto;
    flex-direction: column;
    @media only screen and (min-width: 600px) {
      width: 50%;
    }
    justify-content: center;
    align-items: center;
    align-self: center;
    align-items: center;
  }
  .max {
    max-width: 300px;
    margin: 10px auto;
    p {
      text-align: center;
    }
  }
  .text-message {
    max-width: 300px;
    margin: 5px auto 0px;
    p {
      font-size: 10px;
    }
  }
  .text-label {
    max-width: 300px;
    margin: 0px auto 0px;
    p {
      font-size: 14px;
    }
  }
  p {
    color: white;
  }

  a {
    text-decoration: none;
    color: white;
  }
  button {
    background-color: yellow;
    border-radius: 12px;
    outline: none;
    border-style: none;
    width: 100%;
    cursor: pointer;
    padding: 10px;
  }
  div.img-container {
    display: flex;
    justify-content: center;
    img {
      display: flex;
      padding-top: 0;
      margin: 10px;
    }
  }
`;

const ImageDiv = styled.div`
  height: 50px;
  background-color: #313131;
  width: 50%;
  margin: 50px auto;
  border-radius: 12px;
  @media (max-width: 765px) {
    width: 100%;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Oxanium-Bold";
  font-size: 120px;
  div {
    color: #ffeb32;
  }
`;

export const NotFound = (props) => {
  const variableParams = useMemo(() => {
    return queryString.parse(window.location.search);
  }, []);

  return (
    <Container>
      <div className="outer">
        <div>
          <a href="https://sportreact.com">
            <img src={image} alt="logo" width={"130px"}></img>
          </a>
        </div>
        <ImageDiv>
          <div>404</div>
        </ImageDiv>

        <h1>
          {!!variableParams && !!variableParams.message
            ? variableParams.message
            : "Not found!"}
        </h1>
        {/* <div className="max">
          <p>
            From now on you will be able workout together with{" "}
            {invite_sender_name} ({email})
          </p>
        </div> */}

        <div className="max">
          <a href="sportreact://home" target="_blank" rel="noreferrer">
            <button>CONTINUE IN APP</button>
          </a>
        </div>
        <div className="max">
          <p>You still don't have the sportreact app? Download now!</p>
        </div>
        <div className="ma img-container">
          <a href="https://play.google.com/store/apps/details?id=com.sportreact">
            <img src={android} alt="logo" width={"31px"}></img>
          </a>
          <a href="https://apps.apple.com/hr/app/sportreact/id1606793895">
            <img src={apple} alt="logo" width={"31px"}></img>
          </a>
        </div>
        <div className="max">
          <p>Questions?</p>
          <p>
            Email us at{" "}
            <a href="mailto: info@sportreact.com">info@sportreact.com</a>
          </p>
        </div>
      </div>
    </Container>
  );
};
